import { IApplicationState } from '../../types/redux';

export function selectFlatPrice(state: IApplicationState) {
  return state.fieldsState.flatPrice;
}
